import { Box, Flex, FormControl, FormHelperText, FormLabel, Text } from "@chakra-ui/react";
import Form from "@rjsf/chakra-ui";
import { FormProps } from "@rjsf/core";
import { FieldTemplateProps } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";

import { TEMPLATES } from "@/features/project-process-run-form";

const CustomFieldTemplate = (props: FieldTemplateProps) => {
  const { id, classNames, label, help, required, rawDescription, rawErrors, children } = props;
  if (props.uiSchema?.["isRoot"]) return children;

  return (
    <FormControl position="relative" isRequired={required} className={classNames}>
      <Flex justifyContent="space-between">
        <Box w="1/2" gap={2}>
          {label && <FormLabel htmlFor={id}>{label}</FormLabel>}
          {rawDescription && (
            <Box
              w="full"
              textStyle="sm"
              fontWeight="light"
              fontFamily="roboto"
              color="brand.grey.600"
            >
              {rawDescription}
            </Box>
          )}
        </Box>
        <Box w="full">
          <Box h="fit">{children}</Box>
          {help && <FormHelperText>{help}</FormHelperText>}
          {/* Cant be FormErrorMessage because that doesn't render, use Set so you remove duplicates */}
          {[...new Set(rawErrors)]?.map((error, index) => (
            <Text key={index} color="semantic.error.main" textStyle="sm">
              {error}
            </Text>
          ))}
        </Box>
      </Flex>
    </FormControl>
  );
};

export function AdminForm(props: Omit<FormProps, "validator">) {
  return (
    <Box>
      <Form
        {...props}
        uiSchema={{
          ...props.uiSchema,
          isRoot: true,
          "ui:globalOptions": { label: false },
        }}
        templates={{
          ...TEMPLATES,
          ButtonTemplates: {
            ...TEMPLATES.ButtonTemplates,
            MoveUpButton: () => null,
            MoveDownButton: () => null,
          },
          FieldTemplate: CustomFieldTemplate,
        }}
        validator={validator}
      >
        {props.children}
      </Form>
    </Box>
  );
}
